import {Component, Input} from "@angular/core";
import {MatButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {AppointmentService} from "../../services/appointment.service";

@Component({
  selector: 'viessmann-home-banner',
  templateUrl: './viessmann-home-banner.component.html',
  styleUrls: ['./viessmann-home-banner.component.scss'],
  imports: [
    MatButton,
    TranslateModule
  ],
  standalone: true
})
export class ViessmannHomeBannerComponent {
  @Input() appointmentId: string = '';
  @Input() factoryId: string = '';

  constructor(private appointmentService: AppointmentService,) {
  }

  redirectToViessmannHomeWithInvitationLink(): void {
    this.appointmentService
      .generateInvitationLink(this.appointmentId, this.factoryId)
      .subscribe({
        next: data => {
          if (data && data.url) {
            window.location.href = data.url;
          }
        },
        error: () => {
          window.location.href = "https://home.viessmann-climatesolutions.com";
        }
      });
  }
}
